import React from 'react';
import { View } from 'react-native';
import { useForm } from 'react-hook-form';

import { Fields, defaultValues, useFormSubmit } from 'app/src/elements/forms';
import { Button } from 'app/src/elements/buttons';
import { Loading } from 'app/src/elements/DataState';
import { Notice } from 'app/src/elements/Notice';
import { Title } from 'app/src/styles';
import { useNavigate } from 'app/src/utils/routing';

import { CREATE_CLIENT } from './queries';

export const FIELDS = {
  name: {
    label: 'Name',
    rules: { required: true },
  },
};

const NewClient = () => {
  const navigate = useNavigate();

  const { control, handleSubmit, formState: { errors } } = useForm({
    defaultValues: defaultValues({ fields: FIELDS })
  });

  const { submit: createClient, formStatus, errorMessage } =
    useFormSubmit(CREATE_CLIENT, {
      onCompleted: () => navigate('/clients'),
    });

  const onSubmit = input => {
    createClient({ variables: { input } });
  };

  return (
    <View>
      <Title>Add Client</Title>

      <Fields
        fields={FIELDS}
        control={control}
        errors={errors}
      />

      {errorMessage && <Notice type="error">{errorMessage}</Notice>}

      {'submitting' === formStatus ? (
        <Loading />
      ) : (
        <Button label="Save" onPress={handleSubmit(onSubmit)} wide />
      )}
    </View>
  );
};

export default NewClient;
